const urlParams = new URLSearchParams(window.location.search)

export const language = urlParams.get('language') || 'en' // en, zh_tw, ...

export type Platform = 'ios' | 'googleplay_android' | 'china_android'

export const platform = urlParams.get('platform') as Platform

export const appVersion = urlParams.get('app_version') ?? '0.0.0'

export const debug = urlParams.has('debug')
